<template lang="pug">
      AccountSection.mt-5(message="PASSWORD" :required="true")
        form(autocomplete="off")
          .row(v-show="currentPasswordNeeded")
            .col-sm-12.col-lg-6
              .form-group
                label(for="current-password" required) {{ currentPasswordLabel }}
                input#current-password.form-control(type="password"
                                                    v-model="currentPassword"
                                                    :class="{'is-invalid': currentPasswordInvalid}"
                                                    @input="currentPasswordTouched = true")
                FormError(v-if="currentPasswordInvalid" :message="currentPasswordError")
          .row
            .col-sm-12.col-lg-6
              .form-group
                label(for="new-password" required) New Password
                input#new-password.form-control(type="password"
                                                v-model="newPassword"
                                                :class="{'is-invalid': newPasswordInvalid}"
                                                @input="newPasswordTouched = true")
                FormError(v-if="newPasswordInvalid || passwordAnyInvalid" message="New password is required and must meet the criteria.")
            .col-sm-12.col-lg-6
              .form-group
                label(for="confirm-password" required) Confirm New Password
                input#confirm-password.form-control(type="password"
                                                    v-model="confirmPassword"
                                                    :class="{'is-invalid': confirmPasswordEqualInvalid || confirmPasswordInvalid}"
                                                    @input="confirmPasswordTouched = true")
                FormError(v-if="confirmPasswordEqualInvalid || confirmPasswordInvalid" message="Confirmation password must match the new password.")
          .row
            .col
              PasswordValidator(:length="!passwordLengthInvalid"
                                :userName="!passwordUserNameInvalid"
                                :firstLastName="!passwordFirstLastNameInvalid"
                                :lowercase="!passwordLowercaseInvalid"
                                :uppercase="!passwordUppercaseInvalid"
                                :numeral="!passwordNumeralInvalid"
                                :special="!passwordSpecialInvalid"
                                :repeated="!passwordTwoConsecutiveCharactersInvalid"
                                :consecutiveNumbers="!passwordNineConsecutiveNumbersInvalid"
                                :blankSpace="!passwordWhitespaceInvalid")
          .row.mt-3
            .col
              button.btn.btn-primary.mr-3(@click.prevent="savePassword") {{ saveButtonText }}
              router-link.btn.btn-light(:to="{name: 'my_account'}") Cancel
</template>

<script>
import * as validation from '@/lib/validation'
import AccountSection from '@/components/AccountSection'
import FormError from '@/components/FormError'
import PasswordValidator from '@/components/PasswordValidator'
import stdmsg from '@/lib/stdmsg'

export default {
  name: 'ChangePasswordWidget',
  props: {
    currentPasswordLabel: {
      type: String,
      default: 'Current Password',
    },
    currentPasswordNeeded: {
      type: Boolean,
      default: true,
    },
    saveButtonText: {
      type: String,
      default: 'Save Changes',
    },
    username: {
      type: String,
      default: '',
    },
    firstName: {
      type: String,
      default: '',
    },
    lastName: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      ...validation.mapTouched([
        'currentPassword',
        'newPassword',
        'confirmPassword',
      ]),
    }
  },
  methods: {
    savePassword() {
      let pwords = {
        newPassword: this.newPassword,
        oldPassword: this.currentPassword,
      }
      this.markAllTouched()

      // Let the embedding form know we tried to submit the password, even
      // if it wasn't successful.
      this.$emit('tryPassword', pwords)

      if (
        (this.currentPasswordInvalid && this.currentPasswordNeeded) ||
        this.newPasswordInvalid ||
        this.confirmPasswordInvalid ||
        this.passwordAnyInvalid ||
        this.confirmPasswordEqualInvalid
      ) {
        this.$emit('update:message', stdmsg.formError)
        window.scrollTo(0, 0)
      } else {
        this.$emit('password', pwords)
      }
    },
    ...validation.validationHelpers(),
  },
  computed: {
    ...validation.mapRequired([
      'currentPassword',
      'newPassword',
      'confirmPassword',
    ]),
    ...validation.mapEqual([['confirmPassword', 'newPassword']]),
    ...validation.passwordValidators('newPassword', 'username', 'firstName', 'lastName'),
    currentPasswordError() {
      return (
        this.currentPasswordLabel.charAt(0).toUpperCase() +
        this.currentPasswordLabel.slice(1).toLowerCase() +
        ' is required.'
      )
    },
  },
  components: {
    AccountSection,
    PasswordValidator,
    FormError,
  },
}
</script>

<style lang="scss" scoped>
.error {
  width: 835px;
  margin: auto;
  margin-bottom: 2rem;
}
</style>
